import gql from 'graphql-tag'
export interface SelectionOnMe {
  id: string
  email: string | null
  uid: string | null
  roles: Array<UserRole>
  name: string | null
}

export interface Me {
  user: SelectionOnMe
}

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export default gql`
  query Me {
    user: me {
      id
      email
      uid
      roles
      name
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/me.tsx